import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Stack } from "@mui/material";

export default function UserArchiveUnarchiveConfirm(props) {
  const {
    open,
    accountArchive,
    setAccountArchiveConfirm,
    handleAccountArchive,
    selectedRoles,
    brokerRemoveFun
  } = props;
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const handleChangeyes = (val) => {
    setAccountArchiveConfirm(false);
    handleAccountArchive(val);
  };

  const handleChangeno = () => {
    setAccountArchiveConfirm(false);
  };

  return (
    <>
      <Dialog
        className="user-filter-popup manage-user-filter"
        sx={{ width: "100%" }}
        fullScreen={fullScreen}
        open={open}
        onClose={handleChangeno}
        aria-labelledby="responsive-dialog-title"
      >
        <Stack
          sx={{ p: "25px 25px", pb: "6px" }}
          direction="row"
          alignItems="center"
          spacing={2}
          justifyContent="space-between"
        >
          <Typography className="model-title">
            {accountArchive ? "Unarchive " : "Archive "} User{" "}
          </Typography>
        </Stack>
        <Box sx={{ p: "0px 25px 0px 25px" }}>

        { accountArchive ?

        <p className="label">
        Are you sure you want to unarchive this user?
        </p>
        :

        <p className="label">
        Are you sure you want to archive this user?
        {selectedRoles.includes('Broker') ? " This action will move any open billing statements associated with them to the 'Orphaned Bills'." : ""}
        </p>

        }


          {/* <p className="label">
            Are you sure you want to{" "}
            {accountArchive ? " unarchive " : " archive "} this user?
          </p> */}
        </Box>
        <DialogActions
          sx={{ justifyContent: "flex-start", p: "20px 25px", pt: "21px" }}
        >
          {accountArchive ? (
            <Button className="filter-btn" onClick={() => handleChangeyes(0)}>
              Yes
            </Button>
          ) : (
            <Button className="filter-btn" onClick={() => handleChangeyes(1)}>
              Yes
            </Button>
          )}

          <Button className="cancel-btn" onClick={handleChangeno}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
